import React, { useState, useEffect, useCallback, useReducer } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import usePrevious from 'utils/customHook/usePrevious';
import paramSetterReducer from 'utils/customReducer/paramSetterReducer';
import { customAxiosGetFunction } from 'utils/axiosFunction';
import { getYMDFormatDate } from 'utils/getCustomFormatDate';
import Table from 'utils/table/Table';
import { nvl } from 'utils/nvl';
import makeDataLevel from './makeDataLevel';
import { columnSetter } from './columns';

import { Styles } from 'utils/table/Table.css.js';

const EventLogDetailTable = ({ data, setData, searchMap, setWarningLogIdxs }) => {
  const history = useHistory();
  const loginStatus = useSelector((store) => store.loginManager.status);
  const [canNextPage, setCanNextPage] = useState(false);
  const [canPreviousPage, setCanPreviousPage] = useState(false);
  const [paramState, dispatch] = useReducer(paramSetterReducer, {
    pageIndex: 0,
    pageCount: 0,
    pageSize: 15,
    elementCount: 0,
  });

  useEffect(() => { //없는 페이지 조회 방지.
    dispatch({type: 'PAGE_SELECT', pageIndex: 0});
  }, [searchMap]);
  
  const [columns, setColumns] = useState(columnSetter(0));
  const { moduleIdx, beginDate, endDate, dateValid } = searchMap;
  const prevAmount = usePrevious({ moduleIdx, beginDate, endDate, dateValid });

  const searchTable = useCallback(() => {
    customAxiosGetFunction(history, '/api/log/getWarningByTable', {
      params: {
        ...paramState,
        resolveStatus: 0,
        dateValid: dateValid,
        moduleIdx: searchMap.moduleIdx,
        authIdx: loginStatus.authIdx,
        beginDate: getYMDFormatDate(searchMap.beginDate),
        endDate: getYMDFormatDate(searchMap.endDate),
      },
    }).then((response) => {
      if (nvl(response, null) === null) {
        return false;
      }

      dispatch({ type: 'CHANGE_TOTAL', pageCount: response.totalPages, elementCount: response.totalElements });
      setCanNextPage(!response.last);
      setCanPreviousPage(!response.first);
      
      setWarningLogIdxs(response.content.map((item) => item.warningLogIdx));
      setData(
        nvl(response.content, []).map((d, index) => {
          return {
            ...makeDataLevel(d, paramState.pageIndex, paramState.pageSize, index),
          };
        })
      );
    });
  }, [paramState, searchMap]);

  useEffect(() => {
    if (data.length === 0) {
      if(paramState.pageIndex === 0){
        if(paramState.elementCount !== 0) searchTable();
        else{
          dispatch({ type: 'CHANGE_TOTAL', pageCount: 0, elementCount: 0 });
          setCanNextPage(false);
          setCanPreviousPage(false);
        }
      }else{
        dispatch({type: 'PAGE_SELECT', pageIndex: paramState.pageIndex -1});
      }
      
    }
  }, [data]);

  useEffect(() => {
    if (Number(searchMap.autoReloadTime) === 0 || prevAmount != searchMap) {
      setColumns(columnSetter(searchMap.moduleScn));
      searchTable();
    }
  }, [paramState.pageIndex, searchMap]);

  return (
    <Styles>
      <Table
        columns={columns}
        data={data}
        pageIndex={paramState.pageIndex}
        pageSize={paramState.pageSize}
        pageCount={paramState.pageCount}
        elementCount={paramState.elementCount}
        canNextPage={canNextPage}
        canPreviousPage={canPreviousPage}
        setParamDispatch={dispatch}
      />
    </Styles>
  );
};

export default EventLogDetailTable;
